
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BarChart3, Download, Calendar, TrendingUp } from "lucide-react";

export const SecurityReportsPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <BarChart3 className="h-6 w-6 text-purple-400" />
          <h1 className="text-2xl font-bold">Check-in Reports</h1>
        </div>
        <Button>
          <Download className="h-4 w-4 mr-2" />
          Export Report
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <Calendar className="h-5 w-5 text-blue-500" />
              <span className="text-sm font-medium">Today</span>
            </div>
            <p className="text-2xl font-bold">298</p>
            <p className="text-sm text-muted-foreground">Total check-ins</p>
          </CardContent>
        </Card>

        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <Calendar className="h-5 w-5 text-green-500" />
              <span className="text-sm font-medium">This Week</span>
            </div>
            <p className="text-2xl font-bold">1,847</p>
            <p className="text-sm text-muted-foreground">Total check-ins</p>
          </CardContent>
        </Card>

        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <Calendar className="h-5 w-5 text-purple-500" />
              <span className="text-sm font-medium">This Month</span>
            </div>
            <p className="text-2xl font-bold">7,923</p>
            <p className="text-sm text-muted-foreground">Total check-ins</p>
          </CardContent>
        </Card>

        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <TrendingUp className="h-5 w-5 text-orange-500" />
              <span className="text-sm font-medium">Growth</span>
            </div>
            <p className="text-2xl font-bold">+12%</p>
            <p className="text-sm text-muted-foreground">vs last month</p>
          </CardContent>
        </Card>
      </div>

      <Card className="glass-card">
        <CardHeader>
          <CardTitle>Weekly Check-in Trends</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-64 flex items-center justify-center text-muted-foreground">
            <p>Chart placeholder - would show weekly check-in trends</p>
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="glass-card">
          <CardHeader>
            <CardTitle>Top Venues by Check-ins</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span>Club Infinity</span>
                <span className="font-medium">342 check-ins</span>
              </div>
              <div className="flex justify-between items-center">
                <span>The Basement</span>
                <span className="font-medium">289 check-ins</span>
              </div>
              <div className="flex justify-between items-center">
                <span>Sky Lounge</span>
                <span className="font-medium">201 check-ins</span>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="glass-card">
          <CardHeader>
            <CardTitle>Peak Hours</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span>10:00 PM - 11:00 PM</span>
                <span className="font-medium">89 check-ins</span>
              </div>
              <div className="flex justify-between items-center">
                <span>11:00 PM - 12:00 AM</span>
                <span className="font-medium">124 check-ins</span>
              </div>
              <div className="flex justify-between items-center">
                <span>12:00 AM - 1:00 AM</span>
                <span className="font-medium">67 check-ins</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
